import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ShortNumberPipe } from './short-number.pipe';
import { DateAgoPipe } from './date-ago.pipe';
import { ShortenTextPipe } from './shorten-text.pipe';
import { OrderByPipe } from './orderBy.pipe';
@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
  ],
  declarations: [
    ShortNumberPipe,
    DateAgoPipe,
    ShortenTextPipe,
    OrderByPipe
  ],
  exports: [
    ShortNumberPipe,
    DateAgoPipe,
    ShortenTextPipe,
    OrderByPipe
  ]
})
export class PipesModule { }
